import { FlyerDetailPageEditType } from "../flyer-detail-page-state/flyer-detail-page-state.interface";
import {
  FlyerDetailPageFormComponent,
  FlyerDetailPageFormConfig,
} from "./flyer-detail-page-form-config.interface";
import { FlyerDetailPageFormPosition } from "../../features/flyer-detail-page-form-position/components/flyer-detail-page-form-position/flyer-detail-page-form-position.component";
import { FlyerDetailPageComments } from "../../components/flyer-detail-page-comments/flyer-detail-page-comments.component";
import { FlyerDetailPageFormPage } from "../../features/flyer-detail-page-form-page/components/flyer-detail-page-form-page/flyer-detail-page-form-page.component";
import { FlyerDetailPageAssets } from "../../features/flyer-detail-page-assets/components/flyer-detail-page-assets.component";

function getFlyerDetailPageFormComponents(): FlyerDetailPageFormConfig[] {
  return [
    {
      type: "page",
      component: FlyerDetailPageFormPage,
    },
    {
      type: "assets",
      component: FlyerDetailPageAssets,
    },
    {
      type: "position",
      component: FlyerDetailPageFormPosition,
    },
    {
      type: "comments",
      component: FlyerDetailPageComments,
    },
  ];
}

export const getFormComponent = (type: FlyerDetailPageEditType): FlyerDetailPageFormComponent =>
  getFlyerDetailPageFormComponents().find((config) => config.type === type)?.component || null;
